import {
  ListIcon as ChakraListIcon,
  IconProps,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { customColors } from '../../theme/customColors';
import { OmitSvgChakraProps } from '../../utils/typeUtils';

export interface ListIconProps extends OmitSvgChakraProps<IconProps> {
  colorScheme?: keyof typeof customColors.icon;
}

export const ListIcon = forwardRef<ListIconProps, 'svg'>(
  ({ colorScheme = 'secondary', ...props }, ref) => {
    return (
      <ChakraListIcon
        {...props}
        ref={ref}
        sx={{ color: customColors.icon[colorScheme] }}
      />
    );
  },
);
